import type { EffectCallback } from 'react'
import { useEffect } from 'react'

/**
 * React hook that runs an effect only once.
 */
const useEffectOnce = (effect: EffectCallback) => {
	useEffect(effect, [])
}

export default useEffectOnce
